import { Building2 } from 'lucide-react'
import { WorkspaceInvites } from '@/components/workspace'
import { useWorkspace } from '@/contexts/WorkspaceContext'
import { Skeleton } from '@/components/ui/skeleton'
import { Navigate } from 'react-router-dom'

export function WorkspaceInvitesPage() {
    const { currentWorkspace, loading, error, isAdmin } = useWorkspace()

    // Redirect non-admins
    if (!loading && !isAdmin) {
        return <Navigate to="/app/settings/workspace" replace />
    }

    if (loading) {
        return (
            <div className="p-6 md:p-8 w-full animate-fade-in">
                <div className="max-w-[800px] mx-auto">
                    <div className="mb-8">
                        <Skeleton className="h-8 w-48 mb-2" />
                        <Skeleton className="h-4 w-72" />
                    </div>
                    <Skeleton className="h-64 w-full" />
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="p-6 md:p-8 w-full animate-fade-in">
                <div className="max-w-[800px] mx-auto">
                    <div className="p-6 rounded-lg bg-destructive/10 text-destructive">
                        <h2 className="font-semibold mb-2">Error loading workspace</h2>
                        <p>{error}</p>
                    </div>
                </div>
            </div>
        )
    }

    if (!currentWorkspace) {
        return (
            <div className="p-6 md:p-8 w-full animate-fade-in">
                <div className="max-w-[800px] mx-auto">
                    <div className="text-center py-12">
                        <Building2 className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                        <h2 className="text-2xl font-bold mb-2">No Workspace Selected</h2>
                        <p className="app-page-subtitle">
                            Create a workspace or select one from the sidebar
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-6 md:p-8 w-full animate-fade-in">
            <div className="max-w-[800px] mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="app-page-title mb-1">Team Invitations</h1>
                    <p className="app-page-subtitle">
                        Invite new members to join your workspace
                    </p>
                </div>

                {/* Content */}
                <WorkspaceInvites />
            </div>
        </div>
    )
}
